import Alert from "components/common/Alert";
import { useEffect, useRef, useState } from "react";
import { getExhibitor } from "api/exhibitor.api";
import { useEvents } from "components/events/hooks/useEvents";
import { useExhibitors } from "components/exhibitor/hooks/useExhibitors";
import { getImageUrl } from "utils/imageHelper";

const VISIBILITY_ROLES = [
  "Exhibitors",
  "Events",
  "Offers",
  "Products",
  "Articles",
  "Confirm Page",
];

export default function BannerForm({
  initialData = null,
  onSubmit,
  onClose,
}) {
  const { data, loadEvents } = useEvents();
  // const { exhibitors } = useExhibitors();
  const [exhibitors, setExhibitors] = useState([]);

  const fileInputRef = useRef(null);


  const alertRef = useRef(null);
  const [alert, setAlert] = useState("");

  const [errors, setErrors] = useState({});


  const [form, setForm] = useState({
    company_id:"",
    title: "",
    banner_type: "Hero",
    links_to: "Common",
    redirect_url: "",
    event_id: "",
    exhibitor_id: "",
    start_date: "",
    end_date: "",
    alt_text: "",
    status: "live",
    visibility: [],
  });

  const [bannerMedia, setBannerMedia] = useState(null);

  const [preview, setPreview] = useState(null);

  const [mediaType, setMediaType] = useState("image");

  const [mediaRemoved, setMediaRemoved] = useState(false);



 
  useEffect(() => {
    if (!initialData) return;

    setForm({
      company_id: initialData.company_id?._id || "",
      title: initialData.title || "",
      banner_type: initialData.banner_type || "Hero",
      links_to: initialData.links_to || "Common",
      redirect_url: initialData.link || "",
      event_id: initialData.event_id?._id || "",
      exhibitor_id: initialData.exhibitor_id?._id || "",
      start_date: initialData.start_date
        ? initialData.start_date.slice(0, 16)
        : "",
      end_date: initialData.end_date
        ? initialData.end_date.slice(0, 16)
        : "",
      alt_text: initialData.alt_text || "",
      status: initialData.status || "active",
      visibility: initialData.visibility || [],
    });

     if (initialData.media_type === "video" && initialData.banner_video) {
        setMediaType("video");
        setPreview({
          url: getImageUrl(initialData.banner_video),
          type: "video",
        });
        } else if (initialData.banner_image) {
        setMediaType("image");
        setPreview({
          url: getImageUrl(initialData.banner_image),
          type: "image",
        });
        }

  }, [initialData]);

  useEffect(() => {
    if (alert && alertRef.current) {
      alertRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [alert]);

  useEffect(() => {
  const companyId = localStorage.getItem("company_id");
  if (!companyId) return;

  if (form.links_to === "Event") {
  loadEvents(companyId);
}


  if (form.links_to === "Exhibitor") {
  getExhibitor(companyId)
    .then((res) => setExhibitors(res.data || []))
    .catch(() => setExhibitors([]));
}

  if (form.links_to === "Common") {
    
  }
}, [form.links_to]);

useEffect(() => {
  const companyId = localStorage.getItem("company_id");
  if (!companyId) return;

  if (initialData?.links_to === "Event") {
    loadEvents(companyId);
  }

  if (initialData?.links_to === "Exhibitor") {
    getExhibitor(companyId)
      .then((res) => setExhibitors(res.data || []))
      .catch(() => setExhibitors([]));
  }
}, [initialData]);



  
  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((p) => ({ ...p, [name]: value }));
  };

  const toggleRole = (role) => {
    setForm((p) => ({
      ...p,
      visibility: p.visibility.includes(role)
        ? p.visibility.filter((r) => r !== role)
        : [...p.visibility, role],
    }));
  };

const handleImageChange = (e) => {
  const file = e.target.files?.[0];
  if (!file) return;

  const isImage = file.type.startsWith("image/");
  const isVideo = file.type.startsWith("video/");

  if (!isImage && !isVideo) {
    setErrors((p) => ({ ...p, bannerMedia: "Only image or video files are allowed" }));
    return;
  }

  if (isImage && file.size > 2 * 1024 * 1024) {
    setErrors((p) => ({ ...p, bannerMedia: "Image must be under 2MB" }));
    return;
  }

  if (isVideo && file.size > 20 * 1024 * 1024) {
    setErrors((p) => ({ ...p, bannerMedia: "Video must be under 20MB" }));
    return;
  }

  setErrors((p) => ({ ...p, bannerMedia: "" }));

  setMediaType(isImage ? "image" : "video");
  setBannerMedia(file);

  const url = URL.createObjectURL(file);
  setPreview({
    url,
    type: isImage ? "image" : "video",
  });

  setMediaRemoved(false);
};




  const removeImage = () => {
  setBannerMedia(null);
  setPreview(null);
  setMediaRemoved(true);

  setErrors((p) => ({
    ...p,
    bannerMedia:
      mediaType === "image"
        ? "Banner image is required"
        : "Banner video is required",
  }));

  if (fileInputRef.current) {
    fileInputRef.current.value = "";
  }
};



  const validate = () => {
  const newErrors = {};

  if (!form.title.trim()) {
    newErrors.title = "Banner title is required";
  }

  if (!form.banner_type) {
    newErrors.banner_type = "Banner type is required";
  }

  if (!form.links_to) {
    newErrors.links_to = "Banner link type is required";
  }

  if (form.links_to === "Common" && !form.redirect_url.trim()) {
    newErrors.redirect_url = "Redirect URL is required";
  }

  if (form.links_to === "Event" && !form.event_id) {
    newErrors.event_id = "Event is required";
  }

  if (form.links_to === "Exhibitor" && !form.exhibitor_id) {
    newErrors.exhibitor_id = "Exhibitor is required";
  }

  if (!form.start_date) {
    newErrors.start_date = "Start date is required";
  }

  if (!form.end_date) {
    newErrors.end_date = "End date is required";
  }

  if (form.start_date && form.end_date) {
    if (new Date(form.start_date) > new Date(form.end_date)) {
      newErrors.end_date = "End date must be after start date";
    }
  }

  if (!form.visibility.length) {
    newErrors.visibility = "Select at least one visibility option";
  }

  if (!bannerMedia && (!initialData || mediaRemoved)) {
  newErrors.bannerMedia =
    mediaType === "image"
      ? "Banner image is required"
      : "Banner video is required";
}



  setErrors(newErrors);
  return Object.keys(newErrors).length === 0;
};


  
  const submit = (e) => {
    e.preventDefault();

    const fd = new FormData();

    if (!validate()) {
      setAlert("Please fix the errors below");
      return;
    }

    fd.append("title", form.title);
    fd.append("banner_type", form.banner_type);
    fd.append("links_to", form.links_to);
    fd.append("status", form.status);
    fd.append("alt_text", form.alt_text);

    if (form.redirect_url) fd.append("link", form.redirect_url);
    if (form.event_id) fd.append("event_id", form.event_id);
    if (form.exhibitor_id) fd.append("exhibitor_id", form.exhibitor_id);
    if (form.start_date) fd.append("start_date", form.start_date);
    if (form.end_date) fd.append("end_date", form.end_date);

    if (Array.isArray(form.visibility)) {
      form.visibility.forEach((v) =>
        fd.append("visibility[]", v)
      );
    }


    if (bannerMedia) {
      fd.append("bannerMedia", bannerMedia);
    }

    onSubmit(fd);
  };

  return (
    <form onSubmit={submit} className="space-y-10">
      {alert && (
        <div ref={alertRef}>
          <Alert type="error" message={alert} onClose={() => setAlert("")} />
        </div>
      )}


      <Section title="Banner Details">
        <Input
          label="Banner Title"
          name="title"
          value={form.title}
          onChange={handleChange}
          required
          error={errors.title}
        />

        <SelectInput
          label="Banner Type"
          name="banner_type"
          value={form.banner_type}
          onChange={handleChange}
          required
          error={errors.banner_type}
        >
          <option value="Hero">Hero</option>
          <option value="Popup">Popup</option>
          <option value="Bubble">Bubble</option>
          <option value="Flash">Flash</option>
        </SelectInput>

        <SelectInput
          label="Banner Links To"
          name="links_to"
          value={form.links_to}
          onChange={handleChange}
          required
          error={errors.links_to}
        >
          <option value="Common">Common</option>
          <option value="Event">Event</option>
          <option value="Exhibitor">Exhibitor</option>
        </SelectInput>

        {form.links_to === "Common" && (
          <Input
            label="Redirect URL"
            name="redirect_url"
            value={form.redirect_url}
            onChange={handleChange}
            required
            error={errors.redirect_url}
          />
        )}

        {form.links_to === "Event" && (
          <SelectInput
            label="Select Event"
            name="event_id"
            value={form.event_id}
            onChange={handleChange}
            required
            error={errors.event_id}
          >
            <option value="">Select Event</option>
            {data.map((e) => (
              <option key={e._id} value={e._id}>
                {e.event_name}
              </option>
            ))}
          </SelectInput>
        )}


        {form.links_to === "Exhibitor" && (
          <SelectInput
            label="Select Exhibitor"
            name="exhibitor_id"
            value={form.exhibitor_id}
            onChange={handleChange}
            required
            error={errors.exhibitor_id}
          >
            <option value="">Select Exhibitor</option>
            {exhibitors.map((e) => (
              <option key={e._id} value={e._id}>
                {e.title}
              </option>
            ))}
          </SelectInput>
        )}

         <Input
          type="datetime-local"
          label="Start Date & Time"
          name="start_date"
          value={form.start_date}
          onChange={handleChange}
          required
          error={errors.start_date}
        />

        <Input
          type="datetime-local"
          label="End Date & Time"
          name="end_date"
          value={form.end_date}
          onChange={handleChange}
          required
          error={errors.end_date}
        />

        <SelectInput
          label="Media Type"
          value={mediaType}
          onChange={(e) => {
            setMediaType(e.target.value);
            setPreview(null);
          }}
          required
          error={errors.media_type}
        >
          <option value="image">Image</option>
          <option value="video">Video</option>
        </SelectInput>


        <div className="md:col-span-2 space-y-3">
          <input
            ref={fileInputRef}
            type="file"
            accept="image/png, image/jpeg,video/*"
            onChange={handleImageChange}
            className="w-full rounded-xl border p-3"
          />
          {errors.bannerMedia && (
            <p className="text-xs text-red-500">{errors.bannerMedia}</p>
          )}


          <p className="text-xs text-gray-500">
            Recommended resolution: <b>393×219 px</b>. Accepted file formats:
            <b> JPEG, PNG, MP4, WEPM</b>.
          </p>

          {preview && (
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
              <div className="relative border rounded-xl p-2">
                {preview.type === "image" ? (
                  <img
                    src={preview.url}
                    alt="Preview"
                    className="h-32 w-full object-cover rounded-lg"
                  />
                ) : (
                  <video
                    src={preview.url}
                    controls
                    className="h-32 w-full object-cover rounded-lg"
                  />
                )}

                <button
                  type="button"
                  onClick={removeImage}
                  className="text-xs text-red-600"
                >
                  Remove media
                </button>
              </div>
              </div>
            )}

        </div>

        <Input
          label="Image Alt Text"
          name="alt_text"
          value={form.alt_text}
          onChange={handleChange}
        />

        <SelectInput
          label="Banner Status"
          name="status"
          value={form.status}
          onChange={handleChange}
        >
          <option value="live">Live</option>
          <option value="inactive">Inactive</option>
        </SelectInput>

      </Section>

      <Section title="Visibility">
        <div className="md:col-span-2 flex flex-wrap gap-2">
          {VISIBILITY_ROLES.map((role) => (
            <button
              type="button"
              key={role}
              onClick={() => toggleRole(role)}
              className={`rounded-xl px-4 py-2 text-sm ${
                form.visibility.includes(role)
                  ? "bg-brand-500 text-white"
                  : "bg-gray-100"
              }`}
            >
              {role}
            </button>
          ))}
        </div>
        {errors.visibility && (
            <p className="text-xs text-red-500">{errors.visibility}</p>
          )}
      </Section>

      <div className="flex justify-between">
        <button
          type="button"
          onClick={onClose}
          className="rounded-xl bg-red-500 px-6 py-3 text-white"
        >
          Back
        </button>

        <button
          type="submit"
          className="rounded-xl bg-brand-500 px-6 py-3 text-white"
        >
          {initialData ? "Update Banner" : "Publish Banner"}
        </button>
      </div>
    </form>
  );
}


function Section({ title, children }) {
  return (
    <section>
      <h3 className="mb-4 text-lg font-semibold">{title}</h3>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
        {children}
      </div>
    </section>
  );
}

function Input({ label, required, error, ...props }) {
  return (
    <div>
      <label className="mb-1 block text-sm font-medium">{label}{required && <span className="text-red-500">*</span>}</label>
      <input
        {...props}
        className={`w-full rounded-xl border p-3 ${
          error ? "border-red-500" : ""
        }`}
      />
       {error && (
        <p className="mt-1 text-xs text-red-500">
          {error}
        </p>
      )}
    </div>
  );
}

function SelectInput({ label, required, error, children, ...props }) {
  return (
    <div>
      <label className="mb-1 block text-sm font-medium">
        {label}{required && <span className="text-red-500">*</span>}</label>
      <select {...props} className={`w-full rounded-xl border p-3 ${
          error ? "border-red-500" : ""
        }`}>
        {children}
      </select>
      {error && (
        <p className="mt-1 text-xs text-red-500">
          {error}
        </p>
      )}
    </div>
  );
}
